import gql from "graphql-tag";
const ADD_OR_EDIT_SURVEY = gql`
	mutation ($input: SurveyInput!) {
		addOrEditSurvey(input: $input) {
			id
		}
	}
`;
const COPY_SURVEY = gql`
	mutation ($id: UUID!, $isWithAudience: Boolean!, $input: SurveyInput) {
		copySurvey(id: $id, isWithAudience: $isWithAudience, input: $input) {
			id
			name
			createdById
			createdOn
			isTemplate
			isAnonymous
			startDate
			endDate
			statusId
			numberOfAudience
			numberOfResponses
			lastResponseDate
		}
	}
`;
const DELETE_SURVEY = gql`
	mutation ($id: UUID!) {
		deleteSurvey(id: $id)
	}
`;
const DELETE_SURVEY_AUDIENCE = gql`
	mutation ($id: UUID!) {
		deleteSurveyAudience(id: $id)
	}
`;
const ADD_OR_EDIT_SURVEY_RESPONSE = gql`
	mutation ($input: SurveyResponseInput!) {
		addOrEditSurveyResponse(input: $input) {
			id
		}
	}
`;
const ADD_OR_EDIT_SURVEY_AUDIENCE = gql`
	mutation ($surveyId: UUID!, $input: [SurveyAudienceInput!]!) {
		addOrEditSurveyAudience(surveyId: $surveyId, input: $input) {
			id
			createdOn
			name
			key
			tag
			email
			statusId
			isRepeatedly
		}
	}
`;
export {
  ADD_OR_EDIT_SURVEY,
  ADD_OR_EDIT_SURVEY_AUDIENCE,
  ADD_OR_EDIT_SURVEY_RESPONSE,
  COPY_SURVEY,
  DELETE_SURVEY,
  DELETE_SURVEY_AUDIENCE
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
